import { NgModule } from '@angular/core';

import { BensComponent } from './bens.component';
import { SharedModule } from "../shared/shared.module";
import { BensRoutingModule } from "./bens-routing.module";
import { MarcasModule } from "./marcas/marcas.module";
import { CategoriasModule } from "./categorias/categorias.module";
import { BemTiposModule } from "./bem-tipos/bem-tipos.module";
import { ModelosModule } from "./modelos/modelos.module";
import { SituacoesModule } from "./situacoes/situacoes.module";
import { CoresModule } from "./cores/cores.module";
import { CnhModule } from "./cnh/cnh.module";
import { FormasControleModule } from "./formas-controle/formas-controle.module";

@NgModule({
    imports: [
        SharedModule,
        BemTiposModule,
        CategoriasModule,
        MarcasModule,
        ModelosModule,
        CoresModule,
        SituacoesModule,
        BensRoutingModule,
        CnhModule,
        FormasControleModule
    ],
    declarations: [
        BensComponent
    ]
})
export class BensModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/bens.module.ts
 **/